import ChannelGrid from "./ChannelGrid";
import { useUserJourneyLogger } from "../../hooks/useUserJourneyLogger";
import { useEffect } from "react";

export default function ChannelGridPage({ channelId, refreshKey, refreshEnabled, setRefreshEnabled, refreshIntervalMin, setRefreshIntervalMin, refreshCountdown, manualRefresh, rawVideo, ttvRawVideo }) {

  const { logPageChange } = useUserJourneyLogger({
    channelId,
  });
  useEffect(() => {
    logPageChange({
      chartType: "channelgrid",
    });
  }, [logPageChange]);
  return (
    <ChannelGrid
      rawVideo={rawVideo}
      ttvRawVideo={ttvRawVideo}
      channelId={channelId}
      refreshKey={refreshKey}
      refreshEnabled={refreshEnabled}
      setRefreshEnabled={setRefreshEnabled}
      refreshIntervalMin={refreshIntervalMin}
      setRefreshIntervalMin={setRefreshIntervalMin}
      refreshCountdown={refreshCountdown}
      manualRefresh={manualRefresh}
      enableFourthLine={false}
    />
  );
}
